import { z } from 'zod'

export const ImatchSectionDtoSchema = z.object({
  id: z.string(),
  type: z.enum(['section', 'text', 'table']),
  title: z.string(),
})

export const ImatchResultDtoSchema = z.object({
  file_id: z.string(),
  sections: z.array(ImatchSectionDtoSchema),
})

export const ImatchResponseDtoSchema = z.object({
  matches: z.array(ImatchResultDtoSchema),
})

export type ImatchSectionDto = z.infer<typeof ImatchSectionDtoSchema>
export type ImatchResultDto = z.infer<typeof ImatchResultDtoSchema>
export type ImatchResponseDto = z.infer<typeof ImatchResponseDtoSchema>
